import React from "react";
import DragRail from "web/react/components/drag-rail/drag-rail";
import ProductCard from "web/react/components/product-card/react";
import analytics from "web/script/analytics/analytics";
import { ProductCardSerializer } from "web/types/serializers";
import classnames from "classnames";
import styles from "./top-products.css";

export interface TopProductsProps {
    title: string;
    products: ProductCardSerializer[];
}

export function TopProducts({ title, products }: TopProductsProps): JSX.Element {
    const id = "top-50-products";

    function handleDrag(): void {
        analytics.event("rail", "drag", "homepage-top-products");
    }

    return (
        <DragRail id={id} onDragStart={handleDrag} className={styles.wrapper}>
            <div className={styles.productsContainer}>
                <h2 className={classnames(styles.productCard, styles.titleCard)}>
                    <span className={styles.titleCardText}>{title}</span>
                </h2>
                {products.map((product) => (
                    <div key={product.id} className={styles.productCard}>
                        <ProductCard
                            product={{
                                ...product,
                                show_retailer_as_affiliate: false,
                            }}
                        >
                            <ProductCard.Image width={200} height={250} />

                            <ProductCard.SaveForLaterButton />

                            <ProductCard.Details />
                        </ProductCard>
                    </div>
                ))}
            </div>
        </DragRail>
    );
}

export default TopProducts;
